import { render } from "./top-selling.vue?vue&type=template&id=2c63a4d1"
import script from "./top-selling.vue?vue&type=script&lang=js"
export * from "./top-selling.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Administrador\\PhpstormProjects\\mtex_mobagile_m3_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__